module.exports = __webpack_public_path__ + "img/pause_choosed.2e9f63aa.png";